import { ICurrencyListData } from '@modules/accounting-and-finance/interface/forex.interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: ICurrencyListData[] = [];

export const ACCGCurrencyListSlice = createSlice({
  name: 'accgCurrencyList',
  initialState,
  reducers: {
    setACCGCurrencyList: (
      _state,
      action: PayloadAction<ICurrencyListData[]>,
    ) => {
      return [...action.payload];
    },
    removeACCGCurrencyList: () => {
      return initialState;
    },
  },
});

export default ACCGCurrencyListSlice.reducer;

export const { setACCGCurrencyList, removeACCGCurrencyList } =
  ACCGCurrencyListSlice.actions;
